/**
 * Where the API lives — the ONE place this is decided. Every API call and every
 * direct download link must build its URL from API_BASE_URL.
 *
 * DEV: '' (same origin). The Vite dev server proxies /api and /sanctum to the
 * Laravel API (see vite.config.ts), so the page and the API always share an
 * origin — whether the app is opened on localhost or 127.0.0.1. Sanctum's cookie
 * auth depends on that: previously the page on `localhost` called the API on
 * `127.0.0.1`, the browser treated them as different sites, the XSRF-TOKEN cookie
 * was unreadable, and every login and every write failed with HTTP 419.
 *
 * PRODUCTION: VITE_API_BASE_URL (https://api.bigroi.in), which is same-site with
 * app.bigroi.in. It falls back to the real production API — never to a local
 * address, which would ship a bundle that calls the user's own machine.
 */
export const API_BASE_URL: string = import.meta.env.DEV
  ? ''
  : ((import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'https://api.bigroi.in').replace(/\/$/, '')

/**
 * QA-P01: an API path the server hands out for an <img> or link (`/api/v1/files/…`,
 * `/api/v1/employees/…/photo`) resolved against API_BASE_URL. In dev that is '' (same origin
 * through the proxy); in production the API has its own host, where a bare `/api/…` on the
 * SPA host would hit index.html. Absolute and data: URLs pass through unchanged.
 */
export function apiAssetUrl(path: string | null | undefined): string | null {
  if (!path) return null
  return path.startsWith('/api/') ? API_BASE_URL + path : path
}
